import type { AdminProcess } from './adminProcessDetailsTypes';
import { ServiceType } from '../../../../common/enums/serviceType';
import { translateKey } from '../../../translate';
import { FormDivider } from '../../elements/common';
import { FormLabel } from '../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../elements/forms/InputContainer';
import { InlineReadElement } from '../../elements/inlineReadElement/InlineReadElement';

interface IAdminProcessInvitationDetailsProps {
    adminProcess: AdminProcess;
}

export function AdminProcessInvitationDetails(props: IAdminProcessInvitationDetailsProps) {
    if (props.adminProcess.service.serviceType !== ServiceType.invitation) {
        return null;
    }

    return (
        <>
            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('request.invitationSendTo')}</FormLabel>
                <InputContainer>
                    <InlineReadElement bold>{getEmailadres(props)}</InlineReadElement>
                </InputContainer>
            </HorizontalFormGroupRead>

            <FormDivider />
        </>
    );
}

function getEmailadres(props: IAdminProcessInvitationDetailsProps) {
    return props.adminProcess.relatedProcesses?.find((rp) => rp.customControlData.emailadres)?.customControlData
        .emailadres;
}
